<template>
<popup :showFlag="showFlag"
       @onShowpop="onShowpop">
  <img src="./img/info.png" class="p_info" />
  <div class="opr">
    <div class="takephoto" @click="takephoto('camera')">拍摄</div>
    <div class="takephoto" @click="takephoto('album')">从相册中选取</div>
  </div>
  <div class="cancel" @click="ruleDetail">取消</div>
</popup>
</template>

<script>
import popup from '@/components/popup'
import { mapActions, mapState, mapMutations } from 'vuex'
import { Toast } from 'mint-ui'
export default {
  name: 'photo',
  props: {
    showFlag: {
      type: Boolean,
      default: false
    },
    collectInfo: {
      type: Object,
      default: () => {}
    } // 正对收照片扩展已project_no来判断
  },
  methods: {
    ...mapActions(['uploadPicA', 'makephoto_v2A']),
    ...mapMutations(['setMakePhotoInfo']),
    onShowpop () {
      this.$emit('onControlPhoto')
    },
    chooseImage (type) {
      return new Promise((resolve, reject) => {
        wx.chooseImage({
          count: 1, // 默认9
          sizeType: ['original'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: [type], // 可以指定来源是相册还是相机，默认二者都有
          success: function (res) {
            const localIds = res.localIds // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
            resolve(localIds[0])
          },
          fail () {
            reject('上传失败')
          }
        })
      })
    },
    getImageData (localId) {
      return new Promise((resolve, reject) => {
        wx.getLocalImgData({
          localId, // 图片的localID
          success: function (res) {
            const localData = res.localData.replace(/^.*base64,/, '')
            resolve(localData) // localData是图片的base64数据，可以用img标签显示
          },
          fail () {
            reject('上传失败')
          }
        })
      })
    },
    takephoto (type) {
      console.log('type:::', type)
      this.chooseImage(type).then(res => {
        return this.getImageData(res)
      }).then(res => {
        const data = {
          file: res
        }
        return this.uploadPicA(data)
      }).then(res => {
        console.log('结果：：：', res)
        const { key } = res
        this.originmakephoto(key)
      }).catch(err => {
        err = typeof err === 'string' ? err : '发生错误'
        Toast(err)
      })
    },
    originmakephoto (key) {
      let { makePhotoInfo } = this
      const { spec_id, file_size_max, file_size_min, ppi, width_px, height_px, project_no, needRedirect } = makePhotoInfo
      const formdata = {
        ...spec_id && { spec_id },
        ...project_no && { project_no },
        ...!spec_id && {
          file_size_max,
          file_size_min,
          ppi,
          width_px,
          height_px
        },
        key
      }
      this.makephoto_v2A(formdata).then(res => {
        console.log(res)
        makePhotoInfo = {
          ...makePhotoInfo,
          ...res,
          clothes_path: '',
          algo_filename_no_fm: res.algo_fileuuid,
          inputVal: '',
          wm_url_nofm: res.wm_url,
          wmprinturl_nofm: '',
          wmprinturl: ''
        }
        this.setMakePhotoInfo(makePhotoInfo)
        if (needRedirect) {
          // 为了解决团体预览页面重新拍摄后面制作又重新跳回该页面防止出现两次
          makePhotoInfo.needRedirect = false
          this.setMakePhotoInfo(makePhotoInfo)
          this.$router.replace({
            name: 'Background'
          })
        } else {
          this.$router.push({
            name: 'Background'
          })
        }
      })
    },
    ruleDetail () {
      this.$emit('onRruleDetail')
    }
  },
  components: {
    popup
  },
  computed: {
    ...mapState(['makePhotoInfo'])
  }
}
</script>

<style scoped>
.p_info{
  width:7.02rem;
  display: block;
  margin:0 auto .16rem;
}
.opr{
  width:7.02rem;
  margin:0 auto .16rem;
  border-radius: .16rem;
  overflow: hidden;
  background-color: white;
  text-align: center;
  font-size: .34rem;
  color:#303133;
}
.takephoto{
  height:1.04rem;
  line-height: 1.04rem;
}
.takephoto:first-child{
  border-bottom:.02rem solid rgba(25,31,37,0.08);
}
.activephoto{
  opacity: 0.5;
}
.cancel{
  height:1.04rem;
  line-height: 1.04rem;
  color:rgba(25,31,37,0.4);
  font-size: .34rem;
  background-color: white;
  border-radius: .16rem;
  width:7.02rem;
  text-align: center;
  margin: 0 auto .35rem;
}
</style>
